import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkQueueModel, WorkQueueTypes } from './work-queue.model';

@Injectable({
	providedIn: 'root',
})
export class WorkQueueEventsService {
	private _workQueueUpdated = new Subject<number[]>();
	private _workQueueEntitiesUpdated = new Subject<number[]>();
	private _notifyWorkQueueEntityCompleteUpdated = new Subject<
		[queueId: number, entityId: number, complete: Temporal.Instant | null]
	>();
	private _notifyEntityQueueUpdated = new Subject<
		[
			queue: WorkQueueModel,
			entityId: number,
			updateType: 'add' | 'remove',
			queueType: WorkQueueTypes,
		]
	>();

	get workQueueUpdated$() {
		return this._workQueueUpdated;
	}
	get workQueueEntitiesUpdated$() {
		return this._workQueueEntitiesUpdated;
	}
	get notifyWorkQueueEntityCompleteUpdated$() {
		return this._notifyWorkQueueEntityCompleteUpdated;
	}
	get notifyEntityQueueUpdated$() {
		return this._notifyEntityQueueUpdated;
	}

	public notifyWorkQueueUpdated(queueIds: number[]) {
		this._workQueueUpdated.next(queueIds);
	}
	public notifyWorkQueueEntitiesUpdated(queueIds: number[]) {
		this._workQueueEntitiesUpdated.next(queueIds);
	}
	public notifyWorkQueueEntityCompleteUpdated(
		queueId: number,
		entityId: number,
		complete: Temporal.Instant | null,
	) {
		this._notifyWorkQueueEntityCompleteUpdated.next([
			queueId,
			entityId,
			complete,
		]);
	}
	public notifyEntityQueueUpdated(
		queue: WorkQueueModel,
		entityId: number,
		queueType: WorkQueueTypes,
		updateType: 'add' | 'remove',
	) {
		this._notifyEntityQueueUpdated.next([
			queue,
			entityId,
			updateType,
			queueType,
		]);
	}
}
